import React from 'react';
import { formatMessage } from '../../../utils/format';

interface FormattedMessageProps {
    message: string;
}

export const FormattedMessage: React.FC<FormattedMessageProps> = ({ message }) => {
    const formattedElements = formatMessage(message);
    return <>{formattedElements}</>;
};